import { createFileRoute } from '@tanstack/react-router'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { useState, useEffect } from 'react'
import { apiClient } from '@/lib/api'

export const Route = createFileRoute('/dashboard/billing/invoices')({ 
  component: InvoicesPage
})

function InvoicesPage() {
  const [invoices, setInvoices] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const response = apiClient.api.get('api/billing/invoices').json()
        const data = await apiClient.handleApiResponse<{ invoices?: any[]; data?: any[] }>(response)
        setInvoices(data.invoices || data.data || [])
      } catch (error) {
        console.error('Failed to fetch invoices:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchInvoices()
  }, [])

  return (
    <ProtectedRoute>
      <div className="dashboard-page">
        <div>
          <h1 className="dashboard-page-title">Invoice History</h1>
          <p className="dashboard-page-description">View and download your billing invoices</p>
        </div>

        <Card className="overflow-hidden bg-white/80 shadow-sm">
          <CardHeader className="border-b border-stone-100">
            <CardTitle>Recent Invoices</CardTitle>
            <CardDescription>
              Your billing history and payment records
            </CardDescription>
          </CardHeader>
          <CardContent>
            {loading ? (
              <div className="text-center py-8 text-stone-500">Loading invoices...</div>
            ) : invoices.length === 0 ? (
              <div className="text-center py-8 text-stone-500">
                No invoices found. Invoices will appear here after your first payment.
              </div>
            ) : (
              <div className="space-y-4">
                {invoices.map((invoice) => (
                  <div key={invoice.id} className="flex items-center justify-between rounded-2xl border border-stone-200/80 bg-[#fffdfa] p-4">
                    <div>
                      <p className="font-medium">Invoice #{invoice.number}</p>
                      <p className="text-sm text-stone-600">
                        {new Date(invoice.created_at).toLocaleDateString()}
                      </p>
                    </div>
                    <div className="flex items-center gap-4">
                      <div className="text-right">
                        <p className="font-medium">${(invoice.amount / 100).toFixed(2)}</p>
                        <Badge variant={invoice.status === 'paid' ? 'default' : 'secondary'}>
                          {invoice.status}
                        </Badge>
                      </div>
                      <a 
                        href={invoice.invoice_pdf} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="font-medium text-stone-700 underline underline-offset-4 hover:text-stone-950"
                      >
                        Download
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </ProtectedRoute>
  )
}
